import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { getProductBrandingForIDM } from '../utils/theme';
import SSONavigationBar from '../components/SSONavigationBar';
import NavigationMenu from '../components/NavigationMenu';
import ContentArea from '../components/ContentArea';

const ApplicationContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const NavigationContentContainer = styled.div`
  flex: 1;
  display: flex;
  margin-top: 30px;
  overflow: scroll;
`;

function ApplicationLayout() {
  return (
    <ThemeProvider theme={getProductBrandingForIDM()}>
      <ApplicationContainer>
        <SSONavigationBar />
        <NavigationContentContainer>
          <NavigationMenu />
          <ContentArea />
        </NavigationContentContainer>
      </ApplicationContainer>
    </ThemeProvider>
  );
}

export default ApplicationLayout;
